export const config = {

    apiUrl: '/api',
    baseUrl: '',
    imageUrl: '/storage',

    // apiUrl: 'http://127.0.0.1:8000/api',
    // baseUrl: 'http://127.0.0.1:8000/',
    // imageUrl: 'http://127.0.0.1:8000/storage',
    // webUrl: 'https://sunnahplus.com',
    // videoUrl: 'https://apishop.sunnahplus.com/storage'

    //  apiUrl: 'https://api.a2clothshop.com/api',
    //  baseUrl: 'https://api.a2clothshop.com',
    //  imageUrl: 'https://api.a2clothshop.com/storage',
    //  webUrl: 'https://a2clothshop.com',
    //  videoUrl: 'https://api.a2clothshop.com/storage'

    //  apiUrl: 'https://api.mfuturebd.com/api',
    //  baseUrl: 'https://api.mfuturebd.com',
    //  imageUrl: 'https://api.mfuturebd.com/storage',
    //  webUrl: 'https://mfuturebd.com',
    //  videoUrl: 'https://api.mfuturebd.com/storage'

    // apiUrl: 'https://demoapi.danialdigitalacademy.com/api',
    // baseUrl: 'https://demoapi.danialdigitalacademy.com',
    // imageUrl: 'https://demoapi.danialdigitalacademy.com/storage',
    // webUrl: 'https://demo.danialdigitalacademy.com',
    // videoUrl: 'https://demoapi.danialdigitalacademy.com/storage'
};


